const translations = {
    next: {
      en: "next",
      esp: "siguiente",
      fr: "prochain"
    },
    selectYourPatients: {
        en: "Select Your Patient(s) Below",
        esp: "Seleccione su(s) paciente(s) a continuación",
        fr: "Sélectionnez votre(vos) patient(s) ci-dessous"
    },
    OR:{
        en: "OR",
        esp: "O",
        fr: "OU"
    },
    johnDoe: {
        en: "John Doe",
        esp: "Juan Pérez",
        fr: "Monsieur X"
    },
    johnDoeEmail: {
        en: "johndoe@example.com",
        esp: "juanpérez@example.com",
        fr: "monsieurx@example.com"
    },
    pleaseAddAPatient: {
        en: "Please select or add a patient.",
        esp: "Por favor seleccione o agregue un paciente.",
        fr: "Veuillez sélectionner ou ajouter un patient."
    },
    addNewPatient: {
        en: "Add New Patient",
        esp: "Agregar nuevo paciente",
        fr: "Ajouter un nouveau client"
    },
    numberOfPets: {
        en: "Number of Pets",
        esp: "Número de mascotas",
        fr: "Nombre d'animaux"
    },
    test: {
        en: "test",
        esp: "test",
        fr: "test"
    },
    numberOfPatients: {
        en: "Number of Patients",
        esp: "Número de pacientes",
        fr: "Nombre de patients"
    },
    loginforeasieraccess: {
        en: "Login for easier access!",
        esp: "Inicie sesión para un acceso más fácil",
        fr: "Connectez-vous pour un accès plus facile"
    },
    login: {
        en: "Login",
        esp: "Iniciar sesión",
        fr: "S'identifier"
    },
    enterYourEmailOrPhoneNumber: {
        en: "Enter your email or mobile phone number",
        esp: "Ingrese su correo electrónico o número de teléfono móvil",
        fr: "Entrez votre e-mail ou votre numéro de téléphone mobile"
    },
    enterYourEmail: {
        en: "Enter your email",
        esp: "Introduce tu correo electrónico",
        fr: "Entrer votre Email"
    },
    enterYourPhoneNumber: {
        en: "Enter your mobile phone number",
        esp: "Introduzca su número de teléfono móvil",
        fr: "Entrez votre numéro de téléphone portable"
    },
    password: {
        en: "Password",
        esp: "Contraseña",
        fr: "Mot de passe"
    },
    noAppointments: {
        en: "No Appointment",
        esp: "Sin cita",
        fr: "Pas de rendez-vous"
    },
    forgotYourPassword: {
        en: "Forgot your password?",
        esp: "¿Olvidaste tu contraseña?",
        fr: "Mot de passe oublié?"
    },
    firstTimeLogin: {
        en: "Is this your first time logging in?",
        esp: "¿Es la primera vez que inicias sesión?",
        fr: "C'est la première fois que vous vous connectez ?"
    },
    resetPassword: {
        en: "Reset Password",
        esp: "Restablecer la contraseña",
        fr: "réinitialiser le mot de passe"
    },
    claimAccount: {
        en: "Claim Account",
        esp: "Reclamar cuenta",
        fr: "Compte de réclamation"
    },
    selectAnAppointmentType: {
        en: "Select an Appointment Type",
        esp: "Seleccione un tipo de cita",
        fr: "Sélectionnez un type de rendez-vous"
    },
    verifyingData: {
        en: "Verifying Data",
        esp: "Verificando datos",
        fr: "Vérification des données"
    },
    processingData: {
        en: "Processing data",
        esp: "Procesando datos",
        fr: "Données en cours"
    },
    selectYourAppointment: {
        en: "Select an Appointment Below",
        esp: "Seleccione una cita a continuación",
        fr: "Sélectionnez un rendez-vous ci-dessous"
    },
    desiredDateOfAppointment: {
        en: "Desired Date of Appointment",
        esp: "Fecha deseada de nombramiento",
        fr: "Date désirée d'un rendez-vous"
    },
    noAppointments: {
        en: "No Appointments",
        esp: "Sin citas",
        fr: "sans rendez-vous"
    },
    thisEmailOrPhone: {
        en: "This email or phone already exists with ",
        esp: "Este correo electrónico o teléfono ya existe con ",
        fr: "Cet e-mail ou numéro de téléphone est reconnu comme client de "
    },
    ifThisIsYourFirst: {
        en: ". If this is your first time logging in, please use the 'Reset Password' link below to access your account.",
        esp: "Si es la primera vez que inicia sesión, utilice el enlace 'Restablecer contraseña' a continuación para acceder a su cuenta.",
        fr: "Si c'est la première fois que vous vous connectez, veuillez utiliser le lien «Réinitialiser le mot de passe» ci-dessous pour accéder à votre compte."
    },
    welcome: {
        en: "Welcome",
        esp: "Bienvenidos",
        fr: "Bienvenue"
    },
    clickHereToLogOut: {
        en: "Click here to log out.",
        esp: "Click aqui para salir.",
        fr: "cliquez ici Pour vous déconnecter"
    },
    clickHereToGoBack: {
        en: "Go back.",
        esp: "Regresa.",
        fr: "Retourner."
    },
    showMore: {
        en: "Show More",
        esp: "Mostrar más",
        fr: "Révèlera plus"
    },
    showLess: {
        en: "Show Less",
        esp: "Muestra menos",
        fr: "afficher moins"
    },
    patientName: {
        en: "Patient Name",
        esp: "Nombre del paciente",
        fr: "Nom du patient"
    },
    years: {
        en: "Years",
        esp: "Años",
        fr: "Ans"
    },
    ageMonths: {
        en: "Age Months",
        esp: "Meses de edad",
        fr: "Âge en mois"
    },
    ageDays: {
        en: "Age Days",
        esp: "Meses de edad",
        fr: "Âge en mois"
    },
    ageWeeks: {
        en: "Age Weeks",
        esp: "Meses de edad",
        fr: "Âge en mois"
    },
    ageYears: {
        en: "Age Years",
        esp: "Años de edad",
        fr: "l'âge en années"
    },
    gender: {
        en: "Gender",
        esp: "Género",
        fr: "Le sexe"
    },
    months: {
        en: "Months",
        esp: "Meses",
        fr: "Mois"
    },
    weeks: {
        en: "Weeks",
        esp: "Meses",
        fr: "Mois"
    },
    days: {
        en: "Days",
        esp: "Meses",
        fr: "Mois"
    },
    birthday: {
        en: "Birthday",
        esp: "Cumpleaños",
        fr: "Date d'anniversaire"
    },
    species: {
        en: "Species",
        esp: "Especies",
        fr: "Espèce"
    },
    breed: {
        en: "Breed",
        esp: "Raza",
        fr: "Race"
    },
    weight: {
        en: "Weight",
        esp: "Peso",
        fr: "Poids"
    },
    reasonForVisit: {
        en: "Reason for Visit",
        esp: "Razón de la visita",
        fr: "Raison de la visite"
    },
    update: {
        en: "Update",
        esp: "actualizar",
        fr: "actualiser"
    },
    create: {
        en: "Create",
        esp: "Crear",
        fr: "Créer"
    },
    contact: {
        en: "Contact",
        esp: "Contacto",
        fr: "Information de contact"
    },
    email: {
        en: "Email",
        esp: "Correo electrónico",
        fr: "Email"
    },
    address: {
        en: "Address",
        esp: "la dirección",
        fr: "Adresse"
    },
    title: {
        en: "Title",
        esp: "Título",
        fr: "Titre"
    },
    name: {
        en: "Name",
        esp: "apellido",
        fr: "Nom"
    },
    firstName: {
        en: "First Name",
        esp: "Nombre de pila",
        fr: "Prénom"
    },
    middleInitial: {
        en: "Middle Initial",
        esp: "inicial del segundo nombre",
        fr: "initiale"
    },
    lastName: {
        en: "Last Name",
        esp: "el apellido",
        fr: "Nom de famille"
    },
    mobilePhone: {
        en: "Mobile Phone",
        esp: "Teléfono móvil",
        fr: "Téléphone portable"
    },
    date: {
        en: "Date",
        esp: "Fecha",
        fr: "Date"
    },
    startTime: {
        en: "Start Time",
        esp: "Hora de inicio",
        fr: "Heure de début"
    },
    endTime: {
        en: "End Time",
        esp: "Hora de finalización",
        fr: "Heure de fin"
    },
    unit: {
        en: "Unit",
        esp: "Número de apartamento",
        fr: "Numéro d'appartement"
    },
    city: {
        en: "City",
        esp: "Ciudad",
        fr: "Ville"
    },
    state: {
        en: "State",
        esp: "Estado",
        fr: "État"
    },
    province: {
        en: "Province",
        esp: "Provincia",
        fr: "Province"
    },
    zipCode: {
        en: "Zip Code",
        esp: "Código postal",
        fr: "Code postal"
    },
    postalCode: {
        en: "Postal Code",
        esp: "Código postal",
        fr: "Code postal"
    },
    age: {
        en: "Age",
        esp: "Años",
        fr: "Âge"
    },
    birthdate: {
        en: "Birthdate",
        esp: "Fecha de nacimiento",
        fr: "Date de naissance"
    },
    iAgreeToReceiveTextMessageAlerts: {
        en: "I agree to receive text message alerts",
        esp: "Acepto recibir alertas de mensajes de texto",
        fr: "J'accepte de recevoir des alertes par SMS"
    },
    iAgreeToTheTermsOfService: {
        en: "I agree to the terms of service",
        esp: "Estoy de acuerdo con los términos de servicio",
        fr: "J'accepte les conditions d'utilisation"
    },
    termsOfUse: {
        en: "Terms of Use",
        esp: "Términos de Uso",
        fr: "Conditions d'utilisation"
    },
    privacyPolicy: {
        en: "Privacy Policy",
        esp: "Política de privacidad",
        fr: "Politique de confidentialité"
    },
    submit: {
        en: "Submit",
        esp: "Enviar",
        fr: "Soumettre"
    },
    cancel: {
        en: "Cancel",
        esp: "Cancelar",
        fr: "Annuler"
    },
    thankYou: {
        en: "Thank you",
        esp: "Gracias",
        fr: "Je vous remercie"
    },
    thankYouExclamation: {
        en: "Thank you!",
        esp: "¡Gracias!",
        fr: "Merci!"
    },
    yourAppointmentWith: {
        en: "Your appointment with ",
        esp: "Su cita con ",
        fr: "Votre rendez-vous avec"
    },
    hasBeenConfirmedFor: {
        en: "has been confirmed for ",
        esp: "ha sido confirmado para ",
        fr: "a été confirmé pour"
    },
    lbs: {
        en: "lbs",
        esp: "libras",
        fr: "Kg"
    },
    kg: {
        en: "Kg",
        esp: "Kg",
        fr: "Kg"
    },
    edit: {
        en: "Edit",
        esp: "Editar",
        fr: "Éditer"
    },
    color: {
        en: "Color",
        esp: "Color",
        fr: "Couleur"
    },
    and: {
        en: 'and',
        fr: 'et',
        esp: 'y'
    },
    weLookForwardToSeeingYou: {
        en: "We look forward to seeing you",
        esp: "Esperamos verte",
        fr: "Nous avons hâte de vous voir"
    },
    iAgreeToGrant: {
        en: "I agree to grant ",
        esp: "Estoy de acuerdo en otorgar ",
        fr: "J'accepte d'accorder "
    },
    thankYou: {
        en: "Thank you, ",
        esp: "Gracias, ",
        fr: "Merci, "
    },
    accessToInformation: {
        en: "access to my information.",
        esp: "acceso a mi información.",
        fr: "accéder à mes informations."
    },
    TOSFor: {
        en: "Terms of Service for ",
        esp: "Términos de servicio para ",
        fr: "Conditions d'utilisation pour "
    },
    almostThere: {
        en: "Almost There!",
        esp: "",
        fr: ""
    },
    reviewAndSubmit: {
        en: "Scroll down to review and Submit",
        esp: "",
        fr: ""
    },
    backToStart: {
        en: "Back to Start",
        esp: "Volver a empezar",
        fr: "Retour au début"
    },
    logOut: {
        en: "Log Out",
        esp: "Cerrar sesión",
        fr: "Se déconnecter"
    },
    addedToWaitlist: {
        en: "Click to be added to the waitlist!",
        esp: "¡Haga clic para ser agregado a la lista de espera!",
        fr: "Cliquez pour être ajouté à la liste d'attente!"
    },
    destroyMyWaitlist: {
        en: "Cancel my waitlist entry",
        esp: "",
        fr: ""
    },
    skipToAvailable: {
        en: "Skip to next available appointment",
        esp: "Pasar a la próxima cita disponible",
        fr: "Passer au prochain rendez-vous disponible"
    },
    sorryNoFurtherAppointments: {
        en: "Sorry, this provider does not have any further appointments",
        esp: "Lo sentimos, este proveedor no tiene más citas",
        fr: "Désolé, ce fournisseur n'a plus de rendez-vous"
    },
    noProvideNew: {
        en: "We do not currently provide online booking. Please contact us via phone or email to inquire about scheduling an appointment. We apologize for any inconvenience. Please contact us if you have an urgent case that can not wait for our next available date.", 
        esp: "Nos disculpamos, pero actualmente no estamos aceptando nuevos clientes a través de reservas en línea. Llame a la clínica para concertar una cita.",
        fr: "Nous ne proposons actuellement pas de réservation en ligne. Veuillez nous contacter par téléphone ou par e-mail pour vous renseigner sur la prise de rendez-vous. Nous nous excusons pour tout inconvénient. Veuillez nous contacter si vous avez un cas urgent qui ne peut pas attendre notre prochaine date disponible. Merci"
    },
    noProvideExisting: {
        en: "We do not currently provide online booking. Please contact us via phone or email to inquire about scheduling an appointment. We apologize for any inconvenience. Please contact us if you have an urgent case that can not wait for our next available date.",
        esp: "Nos disculpamos, pero actualmente no aceptamos clientes existentes a través de reservas en línea. Llame a la clínica para concertar una cita.",
        fr: "Nous ne proposons actuellement pas de réservation en ligne. Veuillez nous contacter par téléphone ou par e-mail pour vous renseigner sur la prise de rendez-vous. Nous nous excusons pour tout inconvénient. Veuillez nous contacter si vous avez un cas urgent qui ne peut pas attendre notre prochaine date disponible. Merci"
    },
    noBooking: {
        en: "We do not currently provide online booking. Please contact us via phone or email for more information or to inquire about scheduling an appointment. We apologize for any inconvenience. Thank you!",
        esp: "Actualmente no ofrecemos reservas en línea para su área. Comuníquese con nosotros por teléfono o correo electrónico para obtener más información o para pregunte acerca de programar una cita. Nos disculpamos por cualquier inconveniente. ¡Gracias!",
        fr: "Nous ne proposons actuellement pas de réservation en ligne. Veuillez nous contacter par téléphone ou par e-mail pour vous renseigner sur la prise de rendez-vous. Nous nous excusons pour tout inconvénient. Veuillez nous contacter si vous avez un cas urgent qui ne peut pas attendre notre prochaine date disponible. Merci"
    },
    noBookingForNew: {
        en: "We do not currently provide online booking for new clients. Please contact us via phone or email for more information or to inquire about scheduling an appointment. We apologize for any inconvenience.",
        esp: "Actualmente no proporcionamos reservas en línea para nuevos clientes. Póngase en contacto con nosotros por teléfono o correo electrónico para obtener más información o para solicitar una cita. Nos disculpamos por cualquier inconveniente.",
        fr: "Nous ne proposons pas actuellement de réservation en ligne pour les nouveaux clients. Veuillez nous contacter par téléphone ou par e-mail pour plus d'informations ou pour demander un rendez-vous. Nous nous excusons pour tout inconvénient."
    },
    noBookingForReturning: {
        en: "We do not currently provide online booking for returning clients. Please contact us via phone or email for more information or to inquire about scheduling an appointment. We apologize for any inconvenience.",
        esp: "Actualmente no proporcionamos reservas en línea para clientes que regresan. Póngase en contacto con nosotros por teléfono o correo electrónico para obtener más información o para solicitar una cita. Nos disculpamos por cualquier inconveniente.",
        fr: "Nous ne proposons pas actuellement de réservation en ligne pour les clients qui reviennent. Veuillez nous contacter par téléphone ou par e-mail pour plus d'informations ou pour demander un rendez-vous. Nous nous excusons pour tout inconvénient."
    },
    not: {
        en: "Not ",
        esp: "No ",
        fr: "ne pas"
    },
    monday: {
        en: "Monday",
        esp: "lunes",
        fr: "Lundi"
    },
    tuesday: {
        en: "Tuesday",
        esp: "martes",
        fr: "Mardi"
    },
    wednesday: {
        en: "Wednesday",
        esp: "miércoles",
        fr: "Mercredi"
    },
    thursday: {
        en: "Thursday",
        esp: "jueves",
        fr: "Jeudi"
    },
    friday: {
        en: "Friday",
        esp: "viernes",
        fr: "Vendredi"
    },
    saturday: {
        en: "Saturday",
        esp: "sábado",
        fr: "samedi"
    },
    sunday: {
        en: "Sunday",
        esp: "domingo",
        fr: "dimanche"
    },
    theWeek: {
        en: "The Week",
        esp: "la semana",
        fr: "La semaine"
    },
    jan: {
        en: "Jan",
        esp: "ene",
        fr: "jan"
    },
    feb: {
        en: "Feb",
        esp: "feb",
        fr: "fév"
    },
    mar: {
        en: "Mar",
        esp: "mar",
        fr: "Mar"
    },
    apr: {
        en: "Apr",
        esp: "abr",
        fr: "avr"
    },
    may: {
        en: "May",
        esp: "may",
        fr: "Mai"
    },
    jun: {
        en: "Jun",
        esp: "jun",
        fr: "juin"
    },
    jul: {
        en: "Jul",
        esp: "jul",
        fr: "jui"
    },
    aug: {
        en: "Aug",
        esp: "ago",
        fr: "août"
    },
    go: {
        en: "Go",
        esp: "Vamos",
        fr: "Aller"
    },
    sep: {
        en: "Sep",
        esp: "sep",
        fr: "sep"
    },
    oct: {
        en: "Oct",
        esp: "oct",
        fr: "oct"
    },
    nov: {
        en: "Nov",
        esp: "nov",
        fr: "nov"
    },
    dec: {
        en: "Dec",
        esp: "dic",
        fr: "déc"
    },
    january: {
        en: "January",
        esp: "enero",
        fr: "janvier"
    },
    february: {
        en: "February",
        esp: "febrero",
        fr: "février"
    },
    march: {
        en: "March",
        esp: "marzo",
        fr: "Mars"
    },
    april: {
        en: "April",
        esp: "abril",
        fr: "avril"
    },
    june: {
        en: "June",
        esp: "junio",
        fr: "juin"
    },
    july: {
        en: "July",
        esp: "julio",
        fr: "juillet"
    },
    august: {
        en: "August",
        esp: "agosto",
        fr: "août"
    },
    september: {
        en: "September",
        esp: "septiembre",
        fr: "septembre"
    },
    october: {
        en: "October",
        esp: "octubre",
        fr: "octobre"
    },
    november: {
        en: "November",
        esp: "noviembre",
        fr: "novembre"
    },
    december: {
        en: "December",
        esp: "diciembre",
        fr: "décembre"
    },
    emailOrPhone: {
        en: "Email or Phone",
        esp: "Email o teléfono",
        fr: "Email ou téléphone"
    },
    at: {
        en: "at",
        esp: "a",
        fr: "à"
    },
    selectYourProfile: {
        en: "Select Your Profile",
        fr: "Sélectionnez votre profil",
        esp: "Seleccione su perfil"
    },
    noBookingThisFarOut: {
        en: "This practice does not allow online booking this far into the future.",
        fr: "Cette pratique ne permet pas de réserver en ligne aussi loin dans le futur.",
        esp: "Esta práctica no permite la reserva en línea en un futuro tan lejano."
    }
}
class I18n {
    setLocale(locale){
      this._locale = locale
    }
    translate(key){
        return _.get(translations, `[${key}][${this._locale}]`)
    }
}
I18n.translations = translations
export default I18n


// WEBPACK FOOTER //
// ./lib/i18n.js